import type { ActivityEventType } from "./api";

const GLYPHS: Record<ActivityEventType, string> = {
  report: "📋",
  check_in: "🔌",
  issue: "⚠️",
};

export function EventGlyph({ type }: { type: ActivityEventType }) {
  return (
    <span aria-hidden="true" className="text-fg-mute">
      {GLYPHS[type]}
    </span>
  );
}
